import PropTypes from "prop-types";
import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import MenuCart from "./MenuCart";
import { multilanguage } from "redux-multilanguage";
import {
    isMobile
} from "react-device-detect";
import {
    Drawer
} from "@material-ui/core";
import {
    globalURL
} from "../../../constants";

const IconGroup = ({
    strings,
    wishlist,
    login,
    shoppingCart,
    iconWhiteClass,
    shopPage,
    currentLanguageCode
}) => {
    const handleClick = e => {
        e.currentTarget.nextSibling.classList.toggle("active");
    };

    const search = (search) => {
        if (search.trim().length > 2) {
            let queryResultProduct = shopPage.products.filter(product =>
                String(product.product.productName[currentLanguageCode]).toLocaleLowerCase(currentLanguageCode).includes(String(search).trim().toLocaleLowerCase(currentLanguageCode)));
            let queryResultColor = shopPage.products.filter(product =>
                String(product.color.colorName).toLocaleLowerCase(currentLanguageCode).includes(String(search).trim().toLocaleLowerCase(currentLanguageCode)));
            setSearchResult([...queryResultProduct, ...queryResultColor]);
        } else {
            setSearchResult([]);
        }
    }

    const [isOpenDrawer, toggleDrawer] = useState(false);
    const [searchInput, setValue] = useState("");
    const [searchResult, setSearchResult] = useState([]);
    let history = useHistory();

    const triggerMobileMenu = () => {
        const offcanvasMobileMenu = document.querySelector(
            "#offcanvas-mobile-menu"
        );
        offcanvasMobileMenu.classList.add("active");
    };

    return (
        <div
            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
            className={`header-right-wrap ${iconWhiteClass ? iconWhiteClass : ""}`}
        >
            <div className="same-style header-search d-none d-lg-block">
                <button className="search-active" onClick={() => toggleDrawer(true)}>
                    <i className="pe-7s-search" />
                </button>
                <Drawer anchor={"right"} open={isOpenDrawer} onClose={() => {
                    setSearchResult([])
                    setValue("")
                }}>
                    <div style={{ width: window.innerWidth * 0.35 }}>
                        <div style={{ width: "80%", marginLeft: 20 }} className="form-group">
                            <button onClick={() => {
                                toggleDrawer(false);
                                setSearchResult([]);
                                setValue("");
                            }} style={{ justifyContent: "center", alignItems: "center", display: "flex", background: "none", border: "none", position: "absolute", top: 5, right: 5 }}>
                                <i style={{ fontSize: 35 }} className="pe-7s-close"></i>
                            </button>
                            <div style={{ height: 40, borderBottom: "1px solid gray", display: "flex", flexDirection: "row", alignItems: "center" }}>
                                <input onChange={(e) => setValue(e.target.value)} value={searchInput} onKeyUp={(e) => search(e.target.value)} id="filterInput" type="text" placeholder={strings['header']['iconMenu']['search']} />
                                <i style={{ color: "#333" }} className="pe-7s-search"></i>
                            </div>
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                                {
                                    searchResult.map((item, i) => {
                                        return <a href={process.env.PUBLIC_URL + "/product/" + item.product.seoName + "/" + item.color.colorCode} style={{ margin: "10px 10px 0px 0" }} key={i}>
                                            <img
                                                style={{ width: 110 }}
                                                className="default-img"
                                                src={globalURL + "/images/" + item.images[0].name}
                                                alt={item.product.seoName}
                                            />
                                        </a>


                                    })
                                }
                            </div>
                            <ul className="search-menu" style={{ marginTop: "50%", display: searchResult.length > 0 ? "none" : "block" }}>
                                {
                                    shopPage.categories.map((item, i) => {
                                        return <li key={i}>
                                            <a style={{ fontWeight: "100", color: "#333", fontSize: "smaller" }} href={process.env.PUBLIC_URL + "/shop?category=" + item.categoryCode}>
                                                {String(item.categoryName[currentLanguageCode]).toLocaleUpperCase(currentLanguageCode)}
                                            </a>
                                        </li>
                                    })
                                }

                            </ul>
                        </div>
                    </div>
                </Drawer>

            </div>
            <div className="same-style account-setting d-none d-lg-block">
                <button
                    className="account-setting-active"
                    onClick={e => handleClick(e)}
                >
                    {
                        login.user === null ? <i className="pe-7s-user" /> :
                            <div style={{ minWidth: 120, borderRight: "1px solid #cccc", borderLeft: "1px solid #ccc", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                                <div style={{ flexDirection: "column", display: "flex", marginLeft: 10 }}>
                                    <small style={{ fontSize: 12, textAlign: "left" }}>{String(login.user.name).toLocaleUpperCase("tr-TR")}</small>
                                    <small style={{ fontSize: 12, textAlign: "left", marginTop: -5 }}>{String(login.user.surname).toLocaleUpperCase("tr-TR")}</small>
                                </div>
                                <i style={{ marginLeft: 10 }} className="pe-7s-angle-down"></i>
                            </div>
                    }

                </button>
                <div className="account-dropdown">
                    {
                        login.user === null ?
                            <ul>
                                <li>
                                    <Link style={{ display: "flex", alignItems: "center", flexDirection: "row" }} to={process.env.PUBLIC_URL + "/login-register/login"}>
                                        <i style={{ fontSize: 27 }} className="pe-7s-angle-right"></i> <span style={{ fontSize: "larger" }}>{strings['header']['iconMenu']['login']}</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link style={{ display: "flex", alignItems: "center", flexDirection: "row" }} to={process.env.PUBLIC_URL + "/login-register/register"}>
                                        <i style={{ fontSize: 27 }} className="pe-7s-angle-right"></i> <span style={{ fontSize: "larger" }}>{strings['header']['iconMenu']['register']}</span>
                                    </Link>
                                </li>
                            </ul> :
                            <ul>

                                <li>
                                    <Link style={{ display: "flex", alignItems: "center", flexDirection: "row" }} to={process.env.PUBLIC_URL + "/my-account/detail"}>
                                        <i style={{ fontSize: 27 }} className="pe-7s-angle-right"></i> <span style={{ fontSize: "larger" }}>{strings['header']['iconMenu']['myAccount']}</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link style={{ display: "flex", alignItems: "center", flexDirection: "row" }} to={process.env.PUBLIC_URL + "/my-orders"}>
                                        <i style={{ fontSize: 27 }} className="pe-7s-angle-right"></i> <span style={{ fontSize: "larger" }}>{strings['header']['iconMenu']['myOrders']}</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link style={{ display: "flex", alignItems: "center", flexDirection: "row" }} to={process.env.PUBLIC_URL + "/my-refunds"}>
                                        <i style={{ fontSize: 27 }} className="pe-7s-angle-right"></i> <span style={{ fontSize: "larger" }}>{strings['header']['iconMenu']['myRefunds']}</span>
                                    </Link>
                                </li>

                            </ul>
                    }
                </div>
            </div>
          
            <div className="same-style header-wishlist">
                <Link to={process.env.PUBLIC_URL + "/wishlist"}>
                    <i style={{ fontSize: 27, marginTop: -1 }} className="pe-7s-like" />
                    <span className="count-style">
                        {wishlist.count}
                    </span>
                </Link>
            </div>
            <div className="same-style cart-wrap d-none d-lg-block">
                <button className="icon-cart" onClick={e => {
                    if (login.user !== null) {
                        handleClick(e)
                    } else {
                        history.push("/login-register/login");
                    }
                }}>
                    <i className="pe-7s-shopbag" />
                    <span className="count-style">
                        {shoppingCart.productCount}
                    </span>
                </button>
                {/* menu cart */}

                <MenuCart />
            </div>

            <div className="same-style cart-wrap d-block d-lg-none">
                <Link className="icon-cart" to={process.env.PUBLIC_URL + "/cart"}>
                    <i className="pe-7s-shopbag" />
                    <span className="count-style">
                        {shoppingCart.productCount}
                    </span>
                </Link>
            </div>
            <div className="same-style mobile-off-canvas d-block d-lg-none">
                <button
                    className="mobile-aside-button"
                    onClick={() => triggerMobileMenu()}
                >
                    <i style={{ fontSize: 30, marginTop: -3 }} className="pe-7s-menu" />
                </button>
            </div>
        </div>
    );
};

IconGroup.propTypes = {
    cartData: PropTypes.array,
    compareData: PropTypes.array,
    currency: PropTypes.object,
    iconWhiteClass: PropTypes.string,
    deleteFromCart: PropTypes.func
};

const mapStateToProps = state => {
    return {
        shoppingCart: state.shoppingCart,
        wishlist: state.wishlist,
        login: state.login,
        shopPage: state.shopPage
    };
};


export default connect(mapStateToProps, {

})(multilanguage(IconGroup));
